import script from "./CallMarketing.vue?vue&type=script&setup=true&lang=ts"
export * from "./CallMarketing.vue?vue&type=script&setup=true&lang=ts"

import "./CallMarketing.vue?vue&type=style&index=0&id=d77525b8&scoped=true&lang=less"

import exportComponent from "/data/liulv-h5/liulv-sound/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d77525b8"]])

export default __exports__